import { Component, OnInit } from "@angular/core";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatTableDataSource } from "@angular/material/table";
import { EMRService } from "../EMR.service";
import { DatePipe } from "@angular/common";
import { OpdVisitService } from "app/opdvisits/Services/OpdVisit.service";
import { DashboardService } from "app/dashboard/dashboard.service";
import { FindingSubGroupModel } from "../DoctorModels/findingSubcateory.model";
import { FindingGroupdataModel } from "../DoctorModels/findingsubcategorydata.model";
import { FindingResultModel } from "../DoctorModels/findingResult.model";
import { FindingsModel } from "../DoctorModels/findings.model";
import { FindingMainGroupModel } from "../DoctorModels/findingmaingroup.model";
import { Sort } from "@angular/material/sort";
import { MatCheckboxChange } from "@angular/material/checkbox";
import { AuthService } from "app/auth/auth.service";
@Component({
  selector: "app-ExaminationHelp",
  templateUrl: "./ExaminationHelp.component.html",
  styleUrls: ["./ExaminationHelp.component.scss"],
})
export class ExaminationHelpComponent implements OnInit {
  searchValue02: any;
  findinggroupdata = new MatTableDataSource<FindingGroupdataModel>();
  findingsubgroup = new MatTableDataSource<FindingSubGroupModel>();
  departments_ds = new MatTableDataSource<FindingMainGroupModel>();
  displayedColumns_findingsubdata: string[] = ["finddata", "seq"];
  displayedColumns_departments: string[] = ["surgeryDeptName"];
  displayedColumns_findingsubgroup: string[] = ["examination"];
  result_ds = new MatTableDataSource<FindingResultModel>();
  displayedColumns_result: string[] = ["Result", "RightEye", "LeftEye"];
  rowClicked: any; 
  rowClickedsub: any;
  searchsubGroup: any;
  searchfinding: any;
  specialityDescription: string = "";
  findingDescription: string = "";
  resultDescription: string = "";
  maingroupDescription: string = "";
  isButtonDisabled: boolean = true;
  //examination_added_ds: MatTableDataSource<SurgicalHistoryModel>
  findings_ds: any = new MatTableDataSource<FindingsModel>();
  displayedColumns_examination_added: string[] = [
    "Examination",
    "RightEye",
    "LeftEye",
    "Action",
  ];
  findingarray: any = [];
  findindreult: any = [];
  eyetype: any;
  rowClicked3: any;
  Examid: number = 0;
  rowClicked4: any;
  addresult: number = 4;
  grroupid: number = 0;
  gexampk_id: number = 0;
  findingid: number = 0;
  findsurgeryid: number = 0;
  findingsubArray: any = [];
  searchMainGroup: any;
  searchresult: any;
  constructor(
    private dialog: MatDialog,
    private emrservice: EMRService,
    private datepipe: DatePipe,
    private opdvisitService: OpdVisitService,
    private dashboardService: DashboardService,
    private dialogRef: MatDialogRef<ExaminationHelpComponent>,
    private authservice: AuthService
  ) { }

  ngOnInit() {
    // this.departments_ds.data = this.helplistservice.surgery_departments;

    // this.surgery_ds.data = this.emrservice.surgeryList;
    //this.examination_added_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());

    this.rowClicked = -1;
    this.rowClickedsub = -1;
    this.rowClicked3 = -1;
    this.rowClicked4 = -1;
    this.getFIndingmainAPI(0);
    // this.GetFindingGroupdata(0);
    this.changePostion(1);
  }
  tab1: boolean = true;
  tab2: boolean = false;
  tab3: boolean = false;
  resultSection(event) {
    if (event == 1) {
      this.tab1 = true;
      this.tab2 = false;
      this.tab3 = false;
    } else if (event == 2) {
      this.tab1 = false;
      this.tab2 = true;
      this.tab3 = false;
    } else if (event == 3) {
      this.tab1 = false;
      this.tab2 = false;
      this.tab3 = true;
    }
  }
  AddFinding() {

    var rowdata = this.findinggroupdata.data.filter(
      (item) => item.pk_FindingId == this.findingid
    );
    if (this.tab1 == true) {
      this.changePostion(1);
      this.selectExam(rowdata[0], 1);
    } else if (this.tab2 == true) {
      this.changePostion(2);
      this.selectExam(rowdata[0], 1);
    } else if (this.tab3 == true) {
      if (this.LeftArray.length > 0 || this.rightArray.length > 0) {
        this.selectExam(rowdata[0], 2);
      } else {
        this.dashboardService.openSnackBar(
          "Please check Left or Right Value",
          "OK"
        );
      }
    }
  }
  getFIndingmainAPI(pk_GroupId) {
    // this.departments_ds.data = [];
    this.emrservice.getFIndingmainAPI(pk_GroupId).subscribe((x: any) => {
      if (x.length > 0) {
        this.departments_ds.data = x.filter((item) => item.isActive == true);
        this.grroupid = this.departments_ds.data[0]?.pk_GroupId;
        this.getFindingsubData(this.grroupid);
      } 
    });
  }
  changePostion(type) {
    if (type == 1) {
      this.eyetype = "Normal";
    } else {
      this.eyetype = "";
    }
  }

  newlistarrray: any = [];
  selectExam(row, type) {

    if (type == 1) {
      let checkvalue = this.findings_ds.data.filter(
        (item) => item.fk_FindingId == row.pk_FindingId
      );
      if (checkvalue.length == 0) {
        this.newlistarrray.push({
          pK_TempExamDetailId: 0,
          fK_TemplateId: 0,
          fk_FindingId: row.pk_FindingId,
          pk_SynchId: 0,
          findingName: row.findingName,
          examValues1: this.eyetype,
          examValues2: this.eyetype,
          specification: row.findingName,
          findingSubGroup: null,
          isHidden: false,
          isEdit: false,
        });

        this.findings_ds.data = this.newlistarrray;
        this.GetFindingGroupResult(row.pk_FindingId);
        this.lefteyereult = "";
        this.righteyeresult = "";
        this.isrightChecked = 0;
        this.isleftChecked = 0;
      } else {
        this.dashboardService.openSnackBar(
          "This surgery already Added please select different result",
          "OK"
        );
      }
    } else {
      this.newlistarrray.push({
        pK_TempExamDetailId: 0,
        fK_TemplateId: 0,
        fk_FindingId: row.pk_FindingId,
        pk_SynchId: 0,
        findingName: row.findingName,
        examValues1: this.righteyeresult,
        examValues2: this.lefteyereult,
        specification: row.findingName,
        findingSubGroup: null,
        isHidden: false,
        isEdit: false,
      });

      this.lefteyereult = "";
      this.righteyeresult = "";
      this.LeftArray = [];
      this.rightArray = [];
      //  this.result_ds.data =[];
      this.GetFindingGroupResult(row.pk_FindingId);
      // this.findResultExam(row.pk_FindingId);
      this.findings_ds.data = this.newlistarrray;
    }
  }
  remove(array, to_remove) {
    var elements = array.split(",");
    var remove_index = elements.indexOf(to_remove);
    elements.splice(remove_index, 1);
    var result = elements.join(",");
    return result;
  }
  isrightChecked: number = 0;
  isleftChecked: number = 0;
  lefteyereult: any = "";
  righteyeresult: any = "";
  LeftArray: any = [];
  rightArray: any = [];
  getValue(value: number, index: number, row: any, event: MatCheckboxChange): void {
    if (value === 1) {
        if (event.checked) {
            if (!this.rightArray.includes(row)) {
                this.rightArray.push(row);
            }
        } else {
            const rowIndex = this.rightArray.indexOf(row);
            if (rowIndex > -1) {
                this.rightArray.splice(rowIndex, 1);
            }
        }
        
        this.updateRightEyeResult();
        
    } else if (value === 2) {
        if (event.checked) {
            if (!this.LeftArray.includes(row)) {
                this.LeftArray.push(row);
            }
        } else {
            const rowIndex = this.LeftArray.indexOf(row);
            if (rowIndex > -1) {
                this.LeftArray.splice(rowIndex, 1);
            }
        }
        
        this.updateLeftEyeResult();
        
    } else if (value === 3) {
        if (event.checked) {
            if (!this.rightArray.includes(row)) {
                this.rightArray.push(row);
            }
            if (!this.LeftArray.includes(row)) {
                this.LeftArray.push(row);
            }
        } else {
            const rightIndex = this.rightArray.indexOf(row);
            if (rightIndex > -1) {
                this.rightArray.splice(rightIndex, 1);
            }

            const leftIndex = this.LeftArray.indexOf(row);
            if (leftIndex > -1) {
                this.LeftArray.splice(leftIndex, 1);
            }
        }
        
        this.updateRightEyeResult();
        this.updateLeftEyeResult();
    }
}

 updateRightEyeResult(): void {
    if (this.rightArray.length > 0) {
        this.righteyeresult = this.rightArray.map(item => item.result).join(',');
    } else {
        this.righteyeresult = "";
    }
}

 updateLeftEyeResult(): void {
    if (this.LeftArray.length > 0) {
        this.lefteyereult = this.LeftArray.map(item => item.result).join(',');
    } else {
        this.lefteyereult = "";
    }
}

  chnageExamValue1(index, data) {
    this.findings_ds.data[index].examValues1 = data;
  }
  chnageExamValue2(index, data) {
    this.findings_ds.data[index].examValues2 = data;
  }
  // getValue(value, reult:string ,row,event:MatCheckboxChange): void {
  //   debugger
  //   if (value == 1) {
  //    this.reultdata ={};
  //     if(event.checked ==true){
  //       this.reultdata=row;
  //     this.isrightChecked = 1;
  //    if(this.righteyeresult !='' && this.righteyeresult !=undefined && this.righteyeresult !=null){
  //     this.righteyeresult = this.righteyeresult +','+ reult;
  //    }else{
  //     this.righteyeresult = reult;
  //    }
  //     }else{

  //       this.righteyeresult=this.remove(this.righteyeresult,reult);

  //       if(this.righteyeresult.length >0){
  //         this.reultdata=row;
  //       }else{
  //         this.isrightChecked=0;
  //       }

  //     }

  //   } else {
  //     this.reultdata ={};
  //     if(event.checked ==true){
  //       this.isleftChecked = 1;
  //     if(this.lefteyereult !='' && this.lefteyereult !=undefined && this.lefteyereult !=null){
  //       this.lefteyereult =  this.lefteyereult +','+ reult;
  //      }else{
  //       this.lefteyereult = reult;
  //      }
  //     this.reultdata=row;
  //     }else{
  //       this.righteyeresult=this.remove(this.righteyeresult,reult);
  //       if(this.righteyeresult ==''){
  //         this.isleftChecked=0;
  //       }
  //       if(this.righteyeresult.length >0){
  //         this.reultdata=row;
  //       }else{
  //         this.isleftChecked=0;
  //       }

  //     }

  //   }
  // }
  deletesurgery(row: Object) {
    const index: number = this.newlistarrray.indexOf(row);
    if (index !== -1) {
      this.newlistarrray.splice(index, 1);
      this.findings_ds.data = this.newlistarrray;
    }
  }

  addsurgery() {
    if (Object.keys(this.reultdata).length != 0) {
      this.selectExam(this.reultdata, 2);
    } else {
      this.dashboardService.openSnackBar("Please Select Result", "OK");
    }

    //  this.setotherfields();
    //  this.emrservice.surgicalhistory_client.push(this.emrservice.surgeryhistory_added);
    // this.emrservice.surgeryhistory_added = {};
    // this.examination_added_ds = new MatTableDataSource(this.emrservice.surgicalhistory_client.slice());
  }

  closedialog() {
    this.findings_ds.data = [];
    this.dialogRef.close(this.findings_ds.data);
  }

  setotherfields() {
    this.emrservice.surgeryhistory_added.SurgeryDate = this.datepipe
      .transform(this.emrservice.surgeryhistory_added.SurgeryDate, "MM-dd-yyyy")
      .toString();

    this.emrservice.surgeryhistory_added.pkTranId = 0;
    this.emrservice.surgeryhistory_added.fkRegId =
      this.opdvisitService.patientdetails.pkRegId;
    this.emrservice.surgeryhistory_added.pkSynchId = null;
    this.emrservice.surgeryhistory_added.fkReg = null;

    // console.log("start date " +  this.emrservice.pasthistory_added.startDate);
  }

  applyFilter_surgeries(filterValue: string) {
    this.result_ds.filter = filterValue.trim().toLowerCase();
  }
  applyFilter_finding(filterValue: string) {
    this.findinggroupdata.filter = filterValue.trim().toLowerCase();
  }
  applyFilter(filterValue: string) {
    this.departments_ds.filter = filterValue.trim().toLowerCase();
  }

  savesurgeries() {
    if (this.findings_ds.data.length > 0) {
      this.dialogRef.close(this.findings_ds.data);
    } else {
      this.dashboardService.openSnackBar("Plz transfer data first", "OK");
    }
  }

  save_surgeries_to_server() {
    this.emrservice.save_surgeries_to_server().subscribe(
      (data) => this.success_surgeries_saved(data),
      (err) => this.failed_surgeries_saved(err)
    );
  }
  success_surgeries_saved(data) {
    this.dialog.closeAll();
    this.dashboardService.openSnackBar("Surgery successfully saved", "OK");
    
  }
  failed_surgeries_saved(err) {
    if (err.status == 403) {
      this.dashboardService.openSnackBar("You Don't have Permission", "OK");
    } 
    else if(err.error.statusCode == 422){
      this.dashboardService.openSnackBar(err.error.message,"OK");
    }
    else {
      this.dashboardService.openSnackBar("API Failed", "OK");
    }
  }

  // filterSubGroup(fkgrouid, dname) {

  //   this.grroupid = fkgrouid;
  //   this.findingsubgroup.data = this.findingsubArray.filter(item => item.fk_GroupId == fkgrouid);
  //   this.gexampk_id = this.findingsubgroup.data[0]?.pk_SubGroupId;
  //   this.findinggroupdata.data = this.findingarray.filter(item => item.fK_SubGroupId == fkgrouid);

  //   this.findsurgeryid = this.findinggroupdata.data[0]?.pk_FindingId;
  //   this.result_ds.data = this.findindreult.filter(item => item.fk_FindingId == this.findinggroupdata.data[0]?.pk_FindingId);
  // }
  filterSubGroup(fkgrouid) {
    this.grroupid = fkgrouid;
    this.emrservice.getbysubgroupud(fkgrouid).subscribe(
      (data: any) => {
        this.findingsubgroup.data = data.filter(
          (item) => item.fk_GroupId == fkgrouid
        );
        this.gexampk_id = this.findingsubgroup.data[0]?.pk_SubGroupId;
        this.findinggroupdata.data = this.findingarray.filter( 
          (item) => item.fK_SubGroupId == fkgrouid
        );
        this.findsurgeryid = this.findinggroupdata.data[0]?.pk_FindingId;
        this.result_ds.data = this.findindreult.filter(
          (item) => item.fk_FindingId == this.findinggroupdata.data[0]?.pk_FindingId
        );
        this.GetFindingGroupdata(this.gexampk_id);
      },err =>{
        if (err.status == 403) {
          this.dashboardService.openSnackBar("You Don't have Permission", "OK");
        } 
        else if(err.error.statusCode == 422){
          this.dashboardService.openSnackBar(err.error.message,"OK");
        }
        else {
          this.dashboardService.openSnackBar("API Failed", "OK");
        }
      })

  }
  filterGenExam1(pk_SubGroupId, findingSubGroup) {
    this.gexampk_id = pk_SubGroupId;
    this.findinggroupdata.data = this.findingarray.filter(
      (item) => item.fK_SubGroupId == pk_SubGroupId
    );
    this.findsurgeryid = this.findinggroupdata.data[0]?.pk_FindingId;
    this.result_ds.data = this.findindreult.filter(
      (item) => item.fk_FindingId == this.findinggroupdata.data[0]?.pk_FindingId
    );

    if (this.findinggroupdata.data.length > 0) {
      // this.newlistarrray =[];
      this.findinggroupdata.data.forEach((item) => {
        this.newlistarrray.push({
          pK_TempExamDetailId: 0,
          fK_TemplateId: 0,
          fk_FindingId: item.pk_FindingId,
          pk_SynchId: 0,
          findingName: item.findingName,
          examValues1: this.eyetype,
          examValues2: this.eyetype,
          specification: item.findingName,
          findingSubGroup: null,
          isHidden: false,
          isEdit: false,
        });
      });
      this.findings_ds.data = this.newlistarrray;
    } else {
      this.findings_ds.data = [];
    }
  }

  //sort result
  sortData(sort: Sort) {
    const data = this.newlistarrray.slice();
    if (!sort.active || sort.direction === "") {
      this.findings_ds.data = data;
      return;
    }

    this.findings_ds.data = data.sort((a, b) => {
      const isAsc = sort.direction === "asc";
      switch (sort.active) {
        case "findingName":
          return this.compare(a.findingName, b.findingName, isAsc);
        case "examValues1":
          return this.compare(a.examValues1, b.examValues1, isAsc);
        case "examValues2":
          return this.compare(a.examValues2, b.examValues2, isAsc);

        default:
          return 0;
      }
    });
  }

  compare(a: number | string, b: number | string, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  filterGenExam(pk_SubGroupId) {
    this.gexampk_id = pk_SubGroupId;
    this.emrservice.getfindingdatabysubgid(pk_SubGroupId).subscribe(
      (data: any) => {
        this.findinggroupdata.data = data.filter(
          (item) => item.fK_SubGroupId == pk_SubGroupId
        );
        this.findsurgeryid = this.findinggroupdata.data[0]?.pk_FindingId;
        this.findingid =this.findinggroupdata.data[0]?.pk_FindingId;
        // this.result_ds.data = this.findindreult.filter(
        //   (item) => item.fk_FindingId == this.findinggroupdata.data[0]?.pk_FindingId
        // );
        this.GetFindingGroupResult(this.findsurgeryid);
      })

  }
  deleteobject: any = {};
  // findResult(fingid ,sname?:any) {
  //   this.result_ds.data =[];
  //   if(sname !=undefined && sname !=null){
  //     this.deleteobject=sname;
  //   }
  //   this.findsurgeryid = fingid;
  //   this.result_ds.data = this.findindreult.filter(item => item.fk_FindingId == fingid);
  // }
  findResultExam(fingid) {
    this.findsurgeryid = fingid;
    this.GetFindingGroupResult(this.findsurgeryid);
  }
  // get finding subgroup data
  getFindingsubData(fk_GroupId) {
    // this.findingsubArray = [];
    this.emrservice.getbysubgroupud(fk_GroupId).subscribe(
      (data) => this.success_FindingSubGroup(data),
      (err) => this.failed_FindingSubGroup(err)
    );
  }
  success_FindingSubGroup(data) {
    if (data.length > 0) {
      this.findingsubArray = data.filter((item) => item.isActive == true);

      this.findingsubgroup.data = this.findingsubArray.filter(
        (item) => item.fk_GroupId == this.grroupid
      );
      this.gexampk_id = this.findingsubgroup.data[0]?.pk_SubGroupId;
      this.GetFindingGroupdata(this.gexampk_id);
      
    }
  }
  failed_FindingSubGroup(err) {
    console.log("Api failed");
  }
  GetFindingGroupdata(fk_subGroupId) {
    if(fk_subGroupId > 0) {
    this.emrservice.getfindingdatabysubgid(fk_subGroupId).subscribe(
      (data) => this.success_FindingSubdata(data),
      (err) => this.failed_FindingSubGroup(err)
    );
  }else{
    this.deActiveArray = [];
    this.findingarray = [];
    this.findindreult = [];
  }
  }
  deActiveArray: any = [];
  success_FindingSubdata(data) {
    this.deActiveArray = [];
    this.findingarray = [];
    this.findindreult = [];
    //this.findinggroupdata.data=[];
    if (data.length > 0) {
      this.findingarray = data.filter((item) => item.isActive == true && item.findingName !== null);
      this.deActiveArray = data.filter((item) => item.isActive == false);
      this.findinggroupdata.data = this.findingarray;
      this.findingid = this.findinggroupdata.data[0]?.pk_FindingId;
      this.findsurgeryid = this.findinggroupdata.data[0]?.pk_FindingId;
      this.GetFindingGroupResult(this.findingid);
      this.resultSection(3);
      //  this.findinggroupdata.data=data;
    }
  }
  GetFindingGroupResult(findingid) {
    if(findingid > 0) {
      this.emrservice.getfindingresultbyfindingid(findingid).subscribe(
        (data) => this.success_Findingreult(data),
        (err) => this.failed_FindingSubGroup(err)
      );
    }else{
      this.result_ds.data = [];
    }
   
  }
  success_Findingreult(data) {
    // this.findindreult = [];
    if (data.length > 0) {
      this.result_ds.data = [];
      this.findindreult = data.filter((item) => item.isActive == true);
      this.result_ds.data = this.findindreult;
    }else{
      this.result_ds.data=[];
    }
  }
  changeTableRowColor(idx: any) {
    if (this.rowClicked === idx) {
      this.rowClicked = -1;
    } else {
      this.rowClicked = idx;
    }
  }
  changeTableRow(idx: any) {
    if (this.rowClickedsub === idx) {
      this.rowClickedsub = -1;
    } else {
      this.rowClickedsub = idx;
    }
  }
  changeTablesurgery(idx: any, rowdata) {
    if (this.rowClicked3 === idx) {
      this.rowClicked3 = -1;
    } else {
      this.rowClicked3 = idx;
      this.Examid = rowdata.fK_SubGroupId;
    }
  }
  reultdata: any = {};
  changeTableresult(idx: any, rowdata) {
    this.reultdata = {};
    if (this.rowClicked4 === idx) {
      this.rowClicked4 = -1;
    } else {
      this.rowClicked4 = idx;
      this.reultdata = rowdata;
    }
  }

  //delete pop up open

  changeExamtype(type: number) {
    if (type == 3) {
      this.addresult = 3;
    } else if (type == 4) {
      this.addresult = 4;
    } else if (type == 5) {
      this.addresult = 5;
    } else if (type == 6) {
      this.addresult = 6;
    }
  }

  // insert main group
  addExamhelpdata(type , event) {
    this.isButtonDisabled = true;
    if (type == 6) {

      let filterarray = this.departments_ds.data.filter(item => item.findingGroup !== null);
      const isMatch = filterarray.some(item => item.findingGroup.toLowerCase() === this.maingroupDescription.toLowerCase());
      
      if (isMatch) {
        this.dashboardService.openSnackBar("Already Exists in list", "OK");
        this.maingroupDescription = "";
        this.isButtonDisabled = true;
        return;
      }
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      let payload = {
        FindingGroupMaster: {
          IsEdit: false,
          IsDelete: false,
          Pk_GroupId: 0,
          FindingGroup: this.maingroupDescription,
          IsActive: true,
        },
      };
      this.emrservice.SaveFIndingmainAPI(payload).subscribe(
        (data: any) => {
          if (data["statusCode"] == 1) {
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
              this.getFIndingmainAPI(0);
              this.cancelMainGroupModal();
              this.maingroupDescription = "";
              button.setAttribute('disabled', true);
          }
        },
        (err) => {
          this.dashboardService.openSnackBar(
            "API Failed :" + err.status + " Internal Server Error", "OK");
        }
      );
    } else if (type == 5 && this.grroupid > 0) {
      let subfilterArray = this.findingsubgroup.data.filter(item => item.findingSubGroup !== null)
      const isMatch = subfilterArray.filter(item => item.findingSubGroup.toLowerCase() == this.specialityDescription.toLowerCase());
      if (isMatch.length > 0) {
        this.dashboardService.openSnackBar("Already Exists in  list", "OK");
        this.specialityDescription = "";
        this.isButtonDisabled = true;
        return
      }
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      let payload = {
        FindingSubGroupMaster: {
          IsEdit: false,
          IsDelete: false,
          Pk_SubGroupId: 0,
          Fk_GroupId: this.grroupid,
          FindingSubGroup: this.specialityDescription,
          SeqNo: 1,
          IsActive: true,
        },
      };
      this.emrservice.InsertFindingSubGroupMaster(payload).subscribe(
        (data: any) => {
          if (data["statusCode"] == 1) {
              this.getFindingsubData(this.grroupid);
              this.specialityDescription = "";
              this.cancelSubSpecialityModal();
              this.dashboardService.openSnackBar("Record Saved Successfully","OK");
              button.setAttribute('disabled', true);
          }
        },
        (err) => {
          this.dashboardService.openSnackBar(
            "API Failed :" + err.status + " Internal Server Error", "OK");
        }
      );
    } else if (type == 3 && this.gexampk_id > 0) {

      let findingArrays = this.findinggroupdata.data.filter(item => item.findingName !== null)
      const isMatch = findingArrays.filter(item => item.findingName.toLowerCase() == this.findingDescription.toLowerCase());
      if (isMatch.length > 0) {
        this.dashboardService.openSnackBar("Already Exists in  list", "OK");
        this.findingDescription = "";
        this.isButtonDisabled = true;
        return
      }
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      let payload = {
        FindingMaster: {
          IsEdit: false,
          IsDelete: false,
          Pk_FindingId: 0,
          FK_SubGroupId: this.gexampk_id,
          FindingName: this.findingDescription,
          SeqNo: 1,
          IsActive: true,
        },
      };
      this.emrservice.InsertFindingMaster(payload).subscribe(
        (data: any) => {
          if (data["statusCode"] == 1) {
              this.GetFindingGroupdata(this.gexampk_id);
              this.findingDescription = "";
              this.cancelFindingModal();
              button.setAttribute('disabled', true);
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          }
        },
        (err) => {
          this.dashboardService.openSnackBar(
            "API Failed :" + err.status + " Internal Server Error", "OK");
        }
      );
    } else if (type == 4 && this.findsurgeryid > 0) {

      let findingResult = this.result_ds.data.filter(item => item.result !== null)
      const isMatch = findingResult.filter(item => item.result.toLowerCase() == this.resultDescription.toLowerCase());
      if (isMatch.length > 0) {
        this.dashboardService.openSnackBar("Already Exists in  list", "OK");
        this.resultDescription = "";
        this.isButtonDisabled = true;
        return
      }
      const button = (event.srcElement.disabled === undefined) ? event.srcElement.parentElement : event.srcElement;
      button.setAttribute('disabled', true);
      let payload = {
        FindingResult: {
          IsEdit: false,
          IsDelete: false,
          PK_TranId: 0,
          Fk_FindingId: this.findsurgeryid,
          Result: this.resultDescription,
          IsActive: true,
        },
      };
      this.emrservice.InsertFindingResult(payload).subscribe(
        (data: any) => {
          if (data["statusCode"] == 1) {
              this.GetFindingGroupResult(this.findsurgeryid);
              this.resultDescription = "";
              this.cancelResultModal();
              button.setAttribute('disabled', true);
              this.dashboardService.openSnackBar("Record Saved Successfully", "OK");
          }
        },
        (err) => {
          this.dashboardService.openSnackBar(
            "API Failed :" + err.status + " Internal Server Error", "OK" );
        }
      );
    }
  }
  closePopup(type, optype) {
    if (type == 1) {
      document.getElementById("deActiveModel").style.display = "Block";
    } else {
      document.getElementById("deActiveModel").style.display = "None";
    }
  }
  rowSelect(row) {
    let payload = {
      FindingMaster: {
        IsEdit: true,
        IsDelete: false,
        Pk_FindingId: row.pk_FindingId,
        FK_SubGroupId: row.fK_SubGroupId,
        FindingName: row.findingName,
        SeqNo: 1,
        IsActive: true,
      },
    };
    this.emrservice.InsertFindingMaster(payload).subscribe(
      (data: any) => {
        if (data["statusCode"] == 1) {
          this.GetFindingGroupdata(0);
          document.getElementById("deActiveModel").style.display = "None";
          this.dashboardService.openSnackBar(
            "Record Activated Successfully",
            "OK"
          );
        }
      },
      (err) => {
        this.dashboardService.openSnackBar(
          "API Failed :" + err.status + " Internal Server Error",
          "OK"
        );
      }
    );
  }

  deletepopup(type) {
    if (type == 1) {
      document.getElementById("deleteModal").style.display = "Block";
    } else {
      document.getElementById("deleteModal").style.display = "None";
    }
  }
  deActiveFinding() {
    let payload = {
      FindingMaster: {
        IsEdit: true,
        IsDelete: false,
        Pk_FindingId: this.deleteobject.pk_FindingId,
        FK_SubGroupId: this.deleteobject.fK_SubGroupId,
        FindingName: this.deleteobject.findingName,
        SeqNo: 1,
        IsActive: false,
      },
    };
    this.emrservice.InsertFindingMaster(payload).subscribe(
      (data: any) => {
        if (data["statusCode"] == 1) {
          this.deleteobject = {};
          this.GetFindingGroupdata(0);
          this.result_ds.data = [];
          this.findings_ds.data = [];
          document.getElementById("deleteModal").style.display = "None";
          this.dashboardService.openSnackBar(
            "Record De-Activated Successfully",
            "OK"
          );
        }
      },
      (err) => {
        this.dashboardService.openSnackBar(
          "API Failed :" + err.status + " Internal Server Error",
          "OK"
        );
      }
    );
  }
  deleteResultpopup(type) {
    if (type == 1) {
      document.getElementById("dereusltModal").style.display = "Block";
    } else {
      document.getElementById("dereusltModal").style.display = "None";
    }
  }

  deActiveresult() {
    let payload = {
      FindingResult: {
        IsEdit: true,
        IsDelete: false,
        PK_TranId: this.reultdata.pK_TranId,
        Fk_FindingId: this.reultdata.fk_FindingId,
        Result: this.reultdata.result,
        IsActive: false,
      },
    };
    this.emrservice.InsertFindingResult(payload).subscribe(
      (data: any) => {
        if (data["statusCode"] == 1) {
          this.GetFindingGroupResult(0);
          this.findings_ds.data = [];
          document.getElementById("dereusltModal").style.display = "None";
          this.dashboardService.openSnackBar(
            "Record De-Activated Successfully",
            "OK"
          );
        }
      },
      (err) => {
        this.dashboardService.openSnackBar(
          "API Failed :" + err.status + " Internal Server Error",
          "OK"
        );
      }
    );
  }

  mainGroupModal() {
    document.getElementById("mainGroupModal").style.display = "block";
    
  }
  cancelMainGroupModal() {
    document.getElementById("mainGroupModal").style.display = "none";
    
    this.maingroupDescription = "";
  }

  subSpecialityModal() {
    document.getElementById("subSpecialityModal").style.display = "block";
    
  }
  cancelSubSpecialityModal() {
    document.getElementById("subSpecialityModal").style.display = "none";
    this.specialityDescription = "";
    
  }

  findingModal() {
    document.getElementById("findingModal").style.display = "block";
  }
  cancelFindingModal() {
    document.getElementById("findingModal").style.display = "none";
    this.findingDescription = "";
    this.isButtonDisabled = true;
  }

  resultModal() {
    if (this.findsurgeryid > 0) {
      document.getElementById("resultModal").style.display = "block";
      this.isButtonDisabled = true;
    } else {
      this.dashboardService.openSnackBar("Please add finding", "ok");
    }
  }
  cancelResultModal() {
    document.getElementById("resultModal").style.display = "none";
    this.resultDescription = "";
    this.isButtonDisabled = true;
  }


  enableButton(event: any) {
    const inputValue = event.target.value;
    this.isButtonDisabled = inputValue.trim() === '';
  }
}
